import React, { createContext, useContext, useState, useEffect } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("viriks_cart") || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("viriks_cart", JSON.stringify(items));
  }, [items]);

  const addToCart = (item) => {
    setItems((prev) => {
      const exists = prev.find((i) => i.id === item.id && i.type === item.type);
      if (exists) {
        toast.info("Already in cart");
        return prev;
      }
      toast.success(`${item.title} added to cart`);
      return [...prev, { ...item, qty: 1 }];
    });
  };

  const removeFromCart = (id, type) =>
    setItems((prev) => prev.filter((i) => !(i.id === id && i.type === type)));

  const updateQty = (id, type, qty) =>
    setItems((prev) => prev.map((i) => (i.id === id && i.type === type ? { ...i, qty: Math.max(1, qty) } : i)));

  const clearCart = () => setItems([]);

  const total = items.reduce((s, i) => s + (i.price || 0) * (i.qty || 1), 0);

  return (
    <CartContext.Provider value={{ items, addToCart, removeFromCart, updateQty, clearCart, total }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
